// Toggle Block - Expandable content
class ToggleBlock {
  static get toolbox() {
    return {
      title: 'Toggle',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>'
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ data, config, api, readOnly }) {
    this.data = {
      title: data.title || 'Toggle title',
      content: data.content || '',
      isOpen: data.isOpen || false
    };
    this.readOnly = readOnly;
    this.wrapper = null;
  }

  render() {
    this.wrapper = document.createElement('div');
    this._render();
    return this.wrapper;
  }

  _render() {
    this.wrapper.innerHTML = `
      <div class="toggle-block" data-testid="toggle-block">
        <div class="flex items-start gap-2 cursor-pointer toggle-header">
          <svg class="w-5 h-5 mt-0.5 text-slate-400 transition-transform ${this.data.isOpen ? 'rotate-90' : ''}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
          <span class="toggle-title font-medium text-slate-900 dark:text-white" contenteditable="${!this.readOnly}">${this.data.title}</span>
        </div>
        <div class="toggle-content pl-7 mt-2 ${this.data.isOpen ? '' : 'hidden'}">
          <div class="content-editor text-slate-600 dark:text-slate-400" contenteditable="${!this.readOnly}" data-placeholder="Content...">${this.data.content}</div>
        </div>
      </div>
    `;

    const header = this.wrapper.querySelector('.toggle-header');
    const title = this.wrapper.querySelector('.toggle-title');
    const content = this.wrapper.querySelector('.content-editor');

    header?.addEventListener('click', (e) => {
      if (e.target === title) return;
      this.data.isOpen = !this.data.isOpen;
      this._render();
    });

    if (!this.readOnly) {
      title?.addEventListener('input', (e) => {
        this.data.title = e.target.textContent;
      });
      content?.addEventListener('input', (e) => {
        this.data.content = e.target.innerHTML;
      });
    }
  }

  save() {
    return this.data;
  }
}

export default ToggleBlock;
